import React, { useEffect } from "react";
import Navbar from "../components/homepage/Navbar";
 
import TendersHero from "../components/tenders/TendersHero";
import Tenders from "../components/tenders/Tenders";
import TendersForm from "../components/tenders/TendersForm";
import { Header, Footer } from "../shared";
const TendersPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="BuyCertifiedDrone_backgorund">
      <div className="bg_darkblue">
        <Header />
      </div>
      <TendersHero />
      <Tenders />
      <TendersForm />
      <Footer />
    </div>
  );
};

export default TendersPage;
